export const getEmailFooterHtml = (footerText, unsubscribeText, linkUrl = '#') => `
<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <style>
        body {
            margin: 0;
            padding: 0;
            background-color: #fff;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        }
        .email-footer {
            padding: 24px;
            margin: 16px;
            text-align: center;
        }
        .company-name {
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            margin-bottom: 4px;
        }
        .company-address {
            font-size: 13px;
            color: #666666;
            margin-bottom: 16px;
            line-height: 1.4;
        }
        .unsubscribe-text {
            font-size: 13px;
            color: #666666;
        }
        .unsubscribe-link {
            color: #4caf50;
            text-decoration: none;
            font-weight: 500;
        }
        .unsubscribe-link:hover {
            text-decoration: underline;
        }
    </style>
</head>
<body>
    <div class="email-footer">
        <div class="company-name">{{contactName}}</div>
        <div class="company-address">{{companyAddress}}</div>
        <div class="unsubscribe-text">
            ${footerText} <a href="${linkUrl}" class="unsubscribe-link">${unsubscribeText}</a>
        </div>
    </div>
</body>
</html>
`;
